import React from "react";
import { Button } from "@mui/material";
import { secondaryButtonSx } from "./styles";

function SettingsSecondaryButton({ children, sx, ...props }) {
  return (
    <Button sx={{ ...secondaryButtonSx, ...sx }} {...props}>
      {children}
    </Button>
  );
}

export default SettingsSecondaryButton;
